"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_rawCashBalanceFeed.isIntermediateRecord(tape), `[tape.type:${tape.type}] does not match [artifactType:${types_1.artifactType}]`);
    const { id, externalFilename, creditFacilitySlug, artifactSlug, configuration, } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            externalFilename,
            creditFacilitySlug,
            ...configuration,
        },
    };
    return {
        operationNode: null,
        tapeNode,
    };
};
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node } = params;
    (0, common_1.finleyAssert)(uinode_1.file_rawCashBalanceFeed.isNode(node), `uiNodesToIntermediate: node is not a ${types_1.artifactType} node: ${node.metadata.tapeBuilderNodeType}`);
    const { tapeBuilderNodeId } = node.metadata;
    const { artifactSlug, creditFacilitySlug, externalFilename, ...restConfiguration } = node.configuration;
    const record = {
        id: tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug: null,
        externalFilename,
        configuration: {
            ...restConfiguration,
        },
    };
    return {
        record,
        operationNode: null,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map